module.exports = __webpack_public_path__ + "img/dudle.png";